import "./App.css";
import { Route, Routes } from "react-router-dom";
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import PrivateCustomer from "./PrivateCustomer";
import Login from "./pages/user/Login";
import AdminHome from "./pages/admin/AdminHome";
import HistoryBetAll from "./pages/admin/HistoryBetAll";
import Users from "./pages/admin/Users";
import SetBcr from "./pages/admin/SetBcr";
import SetTX45s from "./pages/admin/SetTX45s";
import SetTX60s from "./pages/admin/SetTX60s";
import SetXD45s from "./pages/admin/SetXD45s";
import SetXD60s from "./pages/admin/SetXD60s";
import SetXS75s from "./pages/admin/SetXS75s";
import SetXS120s from "./pages/admin/SetXS120s";
import Setting from "./pages/admin/Setting";
import Dg2Partners from "./pages/admin/Dg2Partners";
import MongoManager from "./pages/admin/MongoManager";
import DashboardCustomer from "./pages/customer/DashboardCustomer";
import UsersByEmployeeNV from "./pages/customer/UsersByEmployeeNV";
import HistoryBetAllCustomer from "./pages/customer/HistoryBetAllCustomer";
import HistoryCasinoCustomer from "./pages/customer/HistoryCasinoCustomer";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route element={<Login />} path="/" />
                <Route element={<Login />} path="/login" />
                <Route path="/admin" element={<PrivateRouteAdmin />}>
                    <Route index element={<AdminHome />} />
                    <Route element={<Users />} path="users" />
                    <Route element={<HistoryBetAll />} path="history" />
                    <Route element={<SetBcr />} path="setbcr" />
                    <Route element={<SetTX45s />} path="settx45s" />
                    <Route element={<SetTX60s />} path="settx60s" />
                    <Route element={<SetXD45s />} path="setxd45s" />
                    <Route element={<SetXD60s />} path="setxd60s" />
                    <Route element={<SetXS75s />} path="setxs75s" />
                    <Route element={<SetXS120s />} path="setxs120s" />
                    <Route element={<Setting />} path="setting" />
                    <Route element={<Dg2Partners />} path="dg2-keys" />
                    <Route element={<MongoManager />} path="mongo-manager" />
                </Route>
                <Route path="/customer" element={<PrivateCustomer />}>
                    <Route element={<DashboardCustomer />} path="/customer" />
                    <Route element={<UsersByEmployeeNV />} path="usercustomer" />
                    <Route element={<HistoryCasinoCustomer />} path="historyapi" />
                    <Route element={<HistoryBetAllCustomer />} path="history" />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
